import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Suppress warnings from third-party libraries in development
if (process.env.NODE_ENV === 'development') {
	const originalError = console.error;
	console.error = function(...args) {
		if (typeof args[0] === 'string') {
			// Suppress defaultProps warning from react-bootstrap
			if (args[0].includes('Support for defaultProps will be removed')) {
				return;
			}
			// Suppress UNSAFE_componentWillMount warning from react-helmet
			if (args[0].includes('Using UNSAFE_componentWillMount in strict mode')) {
				return;
			}
		}
		originalError.call(console, ...args);
	};
}

const root = ReactDOM.createRoot( document.getElementById( 'root' ) );
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
